import React from 'react'
import './Portfolio.css'
import { Container, Row, Col } from 'reactstrap'
import atradius from '../../assets/atradius_logo.jpg'
import personal_profile from '../../assets/portfolio.png'
const Portfolio = () => {
    const portfolio = [
        {
            logo: atradius,
            name: 'Atradius (Managing Risk and enabling trade).',
            view: false,
            desc:'Atradius is a Financial service system which provides Party, Product, Document - Management systems and various other domains to the customers across the globe. Developed using React JS, OJET technology by interacting and consuming the service APIs that enable user to view and keep track of the bonding business transformation',
            url: '#'
        },
        {
            logo: personal_profile,
            name: 'Personal Portfolio Website',
            view: true,
            desc:'This is a personal portfolio website developer by me using ReactJS',
            url: '#'
        }
    ]
    return (
        <section id='portfolio'  className='mb-5'>
            <Container>
                <Row>
                    <Col lg="12" className="portfolio_top mb-5">
                        <h2> Portfolio </h2>
                    </Col>

                    {portfolio.map((item, index) => <Col key={index} lg='3' md='6' sm='6' className='mb-4'><div className="portfolio_card">
                        <div className="portfolio_img">
                            <img src={item.logo} alt="" className="w-100" />
                        </div>
                        <div className="portfolio_content" style={{overflow:'auto'}}>
                            <div className="content_top" style={{overflow:'auto',padding:'20px'}}>
                                <h5 style={{fontWeight:'bold'}}>{item.name}</h5>
                                <p>{item.desc}</p><br/>
                                {/* <a href={item.url} style={{ pointerEvents: `${item.view ? '' : 'none'}` }}> View Live </a> */}
                            </div>
                        </div>
                    </div>
                    </Col>
                    )}

                </Row>
            </Container>
        </section>
    )
}

export default Portfolio